import React, { FC } from 'react';
import { Container } from '@mui/material';
import { DashboardHeader } from "../../../../UIKit/DashboardHeader";
import { useUiContext } from "../../../../UIProvider";
import { observer } from 'mobx-react-lite';
import { useMagazineCategories } from '../../presenters/useMagazineCategories';
import { MagazineCategoriesTable } from '../components/table';

export const MagazineCategoriesView: FC = observer(() => {
    const { t } = useUiContext();
    const { onGoToCreateMagazineCategory } = useMagazineCategories();

    return (
        <Container maxWidth="xl">
            <DashboardHeader 
                title={t('magazineCategory.magazineCategories')} 
                buttonTitle={t('magazineCategory.createMagazineCategory')} 
                onPress={onGoToCreateMagazineCategory} 
            />
            <MagazineCategoriesTable />
        </Container>
    );
});
